import { render, staticRenderFns } from "./CreateCurrencyExchange.vue?vue&type=template&id=9cfb4f28"
import script from "./CreateCurrencyExchange.vue?vue&type=script&lang=js"
export * from "./CreateCurrencyExchange.vue?vue&type=script&lang=js"
import style0 from "./CreateCurrencyExchange.vue?vue&type=style&index=0&id=9cfb4f28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports